import { render, staticRenderFns } from "./FeePaymentRules.vue?vue&type=template&id=74a16aba&scoped=true&"
import script from "./FeePaymentRules.vue?vue&type=script&lang=js&"
export * from "./FeePaymentRules.vue?vue&type=script&lang=js&"
import style0 from "./FeePaymentRules.vue?vue&type=style&index=0&id=74a16aba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a16aba",
  null
  
)

export default component.exports